"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOperatorsForMeasurementDimension = getOperatorsForMeasurementDimension;
exports.getOperatorsFromMetrics = exports.getOperatorsFromDimensions = exports.getOperatorsFromCustomDimensions = exports.getOperatorsFromAppProtocols = void 0;
var _operators = require("@kentik/ui-shared/dictionary/operators");
var _util = require("@kentik/ui-shared/dictionary/v2/compilers/util");
var _operators2 = require("@kentik/ui-shared/dictionary/content/operators");
var _customDimensionConstants = require("@kentik/ui-shared/dictionary/v2/compilers/customDimensionConstants");
const operatorTypes = {
  INT: _operators.intOperators,
  INET: _operators.inetOperators,
  STR: _operators.stringOperators
};

/**
 * Maps MeasurementDimension.Type values (e.g. 'string', 'int', 'inet') to the appropriate
 * OperatorRecord. String-typed dimensions receive full string + regex operators.
 * Returns undefined when the type is unrecognised or absent.
 */
const measurementDimensionTypeOperators = {
  string: {
    ..._operators.stringOperators,
    ..._operators.regexOperators
  },
  int: _operators.intOperators,
  uint32: _operators.intOperators,
  inet: _operators.inetOperators
};
function getOperatorsForMeasurementDimension(dim) {
  if (!dim?.Type) {
    return undefined;
  }
  return measurementDimensionTypeOperators[dim.Type.toLowerCase()];
}
const getOperatorsFromDimensions = dimensions => Object.fromEntries(dimensions.filter(({
  dataType
}) => dataType).flatMap(dim => (0, _util.getAllDimensionKeys)(dim).map(k => [k, operatorTypes[dim.dataType]])));
exports.getOperatorsFromDimensions = getOperatorsFromDimensions;
const getOperatorsFromMetrics = metrics => Object.fromEntries(metrics.filter(({
  dataType
}) => dataType).map(({
  key,
  dataType
}) => [key, operatorTypes[dataType]]));
exports.getOperatorsFromMetrics = getOperatorsFromMetrics;
const getOperatorsFromAppProtocols = ({
  all
}) => Object.fromEntries(all.map(({
  column: {
    custom_column,
    metadata: {
      allow_regex_filtering
    }
  },
  colKey
}) => {
  if (custom_column.startsWith('INT')) {
    return [colKey, _operators.intOperators];
  }
  if (custom_column.startsWith('INET_')) {
    return [colKey, _operators.inetOperators];
  }
  if (custom_column.startsWith('STR')) {
    return [colKey, allow_regex_filtering ? {
      ..._operators.stringOperators,
      ..._operators.allRegexOperators
    } : _operators.stringOperators];
  }
  if (_operators2.operators[custom_column]) {
    return [colKey, _operators2.operators[custom_column]];
  }
  return [];
}));
exports.getOperatorsFromAppProtocols = getOperatorsFromAppProtocols;
const getOperatorsFromCustomDimensions = columns => Object.fromEntries(columns.map(({
  col_name,
  col_type
}) => [col_name, col_type === 'uint32' ? _customDimensionConstants.uint32Operators : _operators.stringOperators]));
exports.getOperatorsFromCustomDimensions = getOperatorsFromCustomDimensions;